<template>
  <div
    class="dui-review-rating"
    :class="{ 'video-review': videoReview }"
  >
    <DuiRating
      :class="ratingClass"
      :value="rating"
    />
    <DuiIconVideo
      v-if="videoReview"
      class="video-icon icon-yellow icon-xl"
      title="Video review"
    />
  </div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
    ratingClass: {
      type: String,
      default: null,
    },
    videoReview: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-review-rating {
  display: inline-block;
  margin-top: -4px;
  vertical-align: middle;

  &.video-review {
    .dui-rating {
      margin-right: $_1em;
    }

    .video-icon {
      margin-bottom: -3px;
    }
  }
}
</style>
